<template>
    <div class="manual-input">
        <label class="required">
            R Value
        </label>
        <label class="required">
            Omega
        </label>
        <template v-for="row, i in inputValues">
            <div class="text">
                <input type="number" v-model.number="row.r" @change="emitValues" />
            </div>
            <div class="text">
                <input type="number" v-model.number="row.o" @change="emitValues" />
                <i 
                    class="fa fa-trash" 
                    @click="removeRow(i)" 
                    v-if="showRemove(i)"
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        input: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            inputValues: [
                {
                    r: null,
                    o: null
                }
            ]
        }
    },
    methods: {
        emitValues() {
            const filtered = this.inputValues.filter(v => v.r && v.o);

            if (filtered.length > 0) {
                this.$emit('updateManualValues', filtered);
            }

            this.setInputValues(this.inputValues);
        },
        setInputValues(values) {
            const filtered = values.filter(v => v.r || v.o);
            this.inputValues = [
                ...filtered,
                {
                    r: null,
                    o: null
                }
            ];
        },
        showRemove(i) {
            if (this.inputValues[i] === 'undefined') {
                return false;
            }
            if (this.inputValues.length == i + 1) {
                return false;
            }
            return true;
        },
        removeRow(i) {
            if (this.inputValues[i] !== 'undefined') {
                this.inputValues.splice(i,1);
                this.emitValues();
            }

        }
    },
    mounted() {
        this.setInputValues(this.input);
    },
}
</script>

<style>
    .manual-input .text {
        position: relative;
    }
    .manual-input .fa-trash {
        cursor: pointer;
        position: absolute;
        top: .25rem;
        right: -1.25rem;
    }
</style>